import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  formFields: {
    invoiceNo: '',
    issueDateValue: '',
    dueDateValue: '',
    senderDetails: {
      name: '',
      extraFields: []
    },
    recepientDetails: {
      name: '',
      extraFields: []
    },
    allItems: [],
    invoiceSummary: {
      currency: '',
      summarySubtotal: '',
      totalTax: '',
      finalPrice: ''
    },
    invoiceTerms: ''
  },
  isFormfilled: false,
  selectedTemplateId : null,
  currency: ''
  // add other form fields here
}

const invoiceSlice = createSlice({
  name: 'invoice',
  initialState,
  reducers: {
    updateInvoiceForm(state, action) {
      state.formFields = action.payload
      state.isFormfilled = true
    },
    addTemplateId(state, action) {
      state.selectedTemplateId = action.payload
    },
    setCurrency(state, action) {
      state.currency = action.payload
      state.formFields.invoiceSummary.currency = action.payload
    },
    resetInvoiceForm() {
      return initialState
    }
  }
})

export const {
  updateInvoiceForm,
  addTemplateId,
  setCurrency,
  resetInvoiceForm } = invoiceSlice.actions

export default invoiceSlice.reducer
